// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import Dropdown from "components/layout/Dropdown";
import GalleryViewTypeSelectorButton from "./GalleryViewTypeSelectorButton";
import GalleryViewTypeSelectorContent from "./GalleryViewTypeSelectorContent";

// ** Custom Hooks
import useOpenClose from "hooks/useOpenClose";

// ** Contexts
import { DropdownTriggerContext } from "components/layout/Dropdown/DropdownTriggerContext";

// ** Constants
import { topHeaderHeight } from "styles/declares";

// #####################################################
const GalleryViewTypeSelector = ({
	viewType,
	handleViewType,
	galleriesKey,
}) => {
	const { isOpen, close, toggle } = useOpenClose();

	const isClient = useSelector((state) => state.globalCommon.isClient);

	const useLayerOptions = {
		onOutsideClick: () => {
			typeof close === "function" && close();
		},
		placement: "bottom-start",
		triggerOffset: 0,
		container: isClient ? "app" : "root",
	};

	const customLayerStyle = {
		overflowY: "auto",
		maxHeight: `calc((100vh - ${topHeaderHeight.desktop}px) - var(--size-grid))`,
		zIndex: 999,
		borderTopRightRadius: 0,
		borderTopLeftRadius: 0,
		border: "none",
		backgroundColor: isOpen
			? "var(--dz-sys-button-dropdown-open-background-color)"
			: "var(--dz-sys-button-dropdown-background-color)",
	};

	// #####################################################

	return (
		<Dropdown
			isOpen={isOpen}
			close={(insideUseEffect) => {
				close(insideUseEffect);
			}}
			useLayerOptions={useLayerOptions}
			customLayerStyle={customLayerStyle}
			menuContent={() => (
				<GalleryViewTypeSelectorContent
					close={close}
					viewType={viewType}
					handleViewType={handleViewType}
					galleriesKey={galleriesKey}
				/>
			)}
			autoBroderAllDevices
		>
			<DropdownTriggerContext.Consumer>
				{({ triggerProps, layerSide }) => (
					<GalleryViewTypeSelectorButton
						triggerProps={triggerProps}
						isOpen={isOpen}
						toggle={toggle}
						viewType={viewType}
						layerSide={layerSide}
					/>
				)}
			</DropdownTriggerContext.Consumer>
		</Dropdown>
	);
};

// #####################################################

export default GalleryViewTypeSelector;

// #####################################################
